import React from "react";

export const getSeatDescription = (seat, currency) => {
  let description = <>{seat.area}-{seat.side}-{seat.row}-{seat.seat}</>;

  if (seat.ticketTemplate.ticketName) {
    description = <b>{seat.ticketTemplate.ticketName }, {description} </b>;
  }

  return (
    <div>
      {description}
      <div>
        <strong>Refund amount: </strong>
        {seat.ticketTemplate.price}{' '}{currency}
      </div>
    </div>
  );
};
